import React from "react";
import { Dimmer , Loader, Segment } from "semantic-ui-react";

function PostionLoading({ inverted = true, content="PositionLog生成中..."}) {
return (
    
    < Dimmer inverted={inverted} active={true} >
        < Loader size="massive" content={content}/>
    </ Dimmer>
    
)
}

export default PostionLoading;